import React from 'react';
import { Calendar, FileText, Target, Users } from 'lucide-react';

const Roadmap: React.FC = () => {
  return (
    <section id="roadmap" className="py-16 md:py-24 bg-muted">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16 animated-section">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Roadmap</h2>
          <p className="text-lg text-muted-foreground">
            We have an ambitious plan to create lasting impact. Here's what we're working towards.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-12">
            <div className="relative flex items-start animated-section">
              <div className="flex-shrink-0 mr-4">
                <div className="p-3 rounded-full bg-primary/10">
                  <Calendar className="w-6 h-6 text-primary" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Q4 2025: Foundation Building</h3>
                <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border">
                  <ul className="space-y-3 text-muted-foreground">
                    <li>• Establish core team and volunteer network</li>
                    <li>• Launch initial education and skill development programs</li>
                    <li>• Set up infrastructure for community outreach</li>
                    <li>• Begin partnerships with local organizations</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="relative flex items-start animated-section">
              <div className="flex-shrink-0 mr-4">
                <div className="p-3 rounded-full bg-primary/10">
                  <Users className="w-6 h-6 text-primary" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Q3-Q4 2026: Program Expansion</h3>
                <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border">
                  <ul className="space-y-3 text-muted-foreground">
                    <li>• Scale up educational initiatives</li>
                    <li>• Launch environmental conservation projects</li>
                    <li>• Implement healthcare awareness campaigns</li>
                    <li>• Develop digital literacy programs</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="relative flex items-start animated-section">
              <div className="flex-shrink-0 mr-4">
                <div className="p-3 rounded-full bg-primary/10">
                  <FileText className="w-6 h-6 text-primary" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">2027: Sustainable Growth</h3>
                <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border">
                  <ul className="space-y-3 text-muted-foreground">
                    <li>• Establish regional centers</li>
                    <li>• Launch research initiatives</li>
                    <li>• Create sustainable funding channels</li>
                    <li>• Expand volunteer network nationally</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="relative flex items-start animated-section">
              <div className="flex-shrink-0 mr-4">
                <div className="p-3 rounded-full bg-primary/10">
                  <Target className="w-6 h-6 text-primary" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Long-term Vision (2027 and beyond)</h3>
                <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border">
                  <ul className="space-y-3 text-muted-foreground">
                    <li>• International partnerships and collaborations</li>
                    <li>• Launch innovative social impact projects</li>
                    <li>• Establish research and development center</li>
                    <li>• Create sustainable community development models</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;